export class UpdateGaleryImageModel {
    public venueId: string;
    public ExistingPictureUrls: any;
    public Attachments: any;
  }